import { register } from "marko/components"
import component from "./component-browser.js"
register("OTLp+ker", component)
import "./components/follow-ebay-helper-legacy/index.marko?hydrate"